import {
  material_3d_print,
  material_acrylic,
  material_composite,
  material_feldspar,
  material_glass_ceramic,
  material_hybrid_ceramic,
  material_lithium_disilicate,
  material_lithium_silicate,
  material_np_metal,
  material_titanium,
  material_wax,
  material_zirconia,
  material_zirconia_multilayer,
} from 'components/base/images';

export const materialImgList = [
  {
    id: '2',
    src: material_zirconia,
  },
  {
    id: '3',
    src: material_zirconia_multilayer,
  },
  {
    id: '4',
    src: material_acrylic,
  },
  {
    id: '5',
    src: material_wax,
  },
  {
    id: '6',
    src: material_np_metal,
  },
  {
    id: '7',
    src: material_np_metal,
  },
  {
    id: '8',
    src: material_titanium,
  },
  {
    id: '9',
    src: material_lithium_disilicate,
  },
  {
    id: '10',
    src: material_lithium_silicate,
  },
  {
    id: '11',
    src: material_composite,
  },
  {
    id: '12',
    src: material_hybrid_ceramic,
  },
  {
    id: '13',
    src: material_glass_ceramic,
  },
  {
    id: '14',
    src: material_feldspar,
  },
  {
    id: '15',
    src: '',
  },
  {
    id: '16',
    src: '',
  },
  {
    id: '17',
    src: '',
  },
  {
    id: '18',
    src: '',
  },
  {
    id: '19',
    src: '',
  },
  {
    id: '20',
    src: '',
  },
  {
    id: '21',
    src: '',
  },
  {
    id: '22',
    src: '',
  },
  {
    id: '23',
    src: material_3d_print,
  },
];
